import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";
import { FiPhone, FiMail, FiFacebook, FiInstagram } from "react-icons/fi";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-top">
        <div className="container">

          {/* Brand */}
          <div className="footer-brand">
            <div className="footer-logo">
              <img
                src="/assets/img/logo.png"
                alt="سوريا للعقارات"
                className="footer-logo-image"
              />
              <div>
                <h3>سوريا للعقارات</h3>
                <p className="footer-url">SYRIANREALSTATE.NET</p>
              </div>
            </div>

            <p className="footer-text">
              نحن شركة رائدة في سوق العقارات السوري، نقدم خدمات بيع وشراء وتأجير
              العقارات بكل احترافية وموثوقية.
            </p>

            <ul className="social-list">
              <li>
                <a href="#" className="social-link" aria-label="Facebook">
                  <FiFacebook />
                </a>
              </li>
              <li>
                <a href="#" className="social-link" aria-label="Instagram">
                  <FiInstagram />
                </a>
              </li>
            </ul>
          </div>

          {/* Links */}
          <div className="footer-link-box">
            <ul className="footer-list">
              <p className="footer-list-title">الخدمات</p>
              <li><Link to="/properties?type=buy" className="footer-link">شراء عقار</Link></li>
              <li><Link to="/properties?type=rent" className="footer-link">تأجير عقار</Link></li>
              <li><Link to="/properties" className="footer-link">جميع العقارات</Link></li>
            </ul>

            <ul className="footer-list">
              <p className="footer-list-title">روابط سريعة</p>
              <li><Link to="/#home" className="footer-link">الرئيسية</Link></li>
              <li><Link to="/#about" className="footer-link">من نحن</Link></li>
              <li><Link to="/contact" className="footer-link">اتصل بنا</Link></li>
            </ul>

            <ul className="footer-list">
              <p className="footer-list-title">معلومات الاتصال</p>

              <li>
                <a href="tel:+963985148289" className="footer-link number">
                  <FiPhone className="icon" /> +963 985 148 289
                </a>
              </li>

              <li>
                <a href="tel:+966535706325" className="footer-link number">
                  <FiPhone className="icon" /> +966 535 706 325
                </a>
              </li>

              <li>
                <a href="mailto:info@syrianrealestate.net" className="footer-link">
                  <FiMail className="icon" /> info@syrianrealestate.net
                </a>
              </li>
            </ul>
          </div>

        </div>
      </div>

      <div className="footer-bottom">
        <div className="container">
          <p className="copyright">
            &copy; {new Date().getFullYear()} سوريا للعقارات. جميع الحقوق محفوظة.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
